export const graphViewPeriod = {
  day: "day",
  month: "month",
  year: "year"
};

export const graphViewPeriodFault = {
  dayStart: "day",
  monthStart: "month",
  yearStart: "year",
  dayEnd: "day",
  monthEnd: "month",
  yearEnd: "year",
  range: "range"
};

// Gradient colors for the bar series
export const gradientColors = [
  ['#FFD700', '#FFA500'], // Gradient for the first series (yellow)
  ['#59C1BD', '#3E54AC'], // Gradient for the second series (blue)
  ['#BFE283', '#7FB200'], // Gradient for the third series (light green to green)
  ['#90BAFE', '#3A70B9'], // Gradient for the fourth series (light blue to blue)
  ['#F28F43', '#D35400'], // Gradient for the fifth series (orange)
  ['#33C6E7', '#1A88A6'], // Gradient for the sixth series (cyan to blue)
  ['#FF6F61', '#D23600'], // Gradient for the seventh series (coral to dark red)
  ['#6B8E23', '#556B2F'], // Gradient for the eighth series (olive to dark olive green)
  ['#8FBC8F', '#2E8B57'], // Gradient for the ninth series (sea green)
  ['#FFE4B5', '#FFA07A'], // Gradient for the tenth series (moccasin to light salmon)
  ['#FFDFC4', '#F1C27D'], // Gradient for the ninth series (skin tone)
  ['#5F9EA0', '#4682B4'], // Gradient for the twelfth series (cadet blue to steel blue)
  ['#FF4500', '#FF6347'], // Gradient for the thirteenth series (orange red to tomato)
  ['#7FFF00', '#7CFC00'], // Gradient for the fourteenth series (chartreuse to lawn green)
  ['#D2691E', '#A52A2A'], // Gradient for the fifteenth series (chocolate to brown)
  ['#6A5ACD', '#483D8B'], // Gradient for the sixteenth series (slate blue to dark slate blue)
  ['#00CED1', '#20B2AA'], // Gradient for the seventeenth series (dark turquoise to light sea green)
  ['#FFDAB9', '#EEE8AA'], // Gradient for the eighteenth series (peach puff to pale goldenrod)
  ['#B22222', '#FF0000'], // Gradient for the nineteenth series (firebrick to red)
  ['#ADFF2F', '#32CD32'], // Gradient for the twentieth series (green yellow to lime green)
  ['#00FA9A', '#00FF7F'], // Gradient for the twenty-first series (medium spring green to spring green)
  ['#4682B4', '#1E90FF'], // Gradient for the twenty-second series (steel blue to dodger blue)
  ['#DA70D6', '#DDA0DD'], // Gradient for the twenty-third series (orchid to plum)
  ['#FF7F50', '#FF4500'], // Gradient for the twenty-fourth series (coral to orange red)
  ['#40E0D0', '#48D1CC'], // Gradient for the twenty-fifth series (turquoise to medium turquoise)
  ['#8B4513', '#A0522D'], // Gradient for the twenty-sixth series (saddle brown to sienna)
  ['#D8BFD8', '#DDA0DD'], // Gradient for the twenty-seventh series (thistle to plum)
];

export const timezone = [
  { value:"2", timezone: "US/Samoa", name: '(GMT-11) Midway Island, Samoa, Bering Straits' },
  { value:"3", timezone: "US/Hawaii", name: '(GMT-10) Hawaii, Aleutian Islands' },
  { value:"4", timezone: "Pacific/Marquesas", name: '(GMT-9:30) French Polynesia, Marquesas Islands' },
  { value:"5", timezone: "US/Alaska", name: '(GMT-9) Alaska' },
  { value:"6", timezone: "America/Ensenada", name: '(GMT-8) Pacific Time (US & Canada), Tijuana' },
  { value:"7", timezone: "merica/Boise", name: '(GMT-7) Mountain Time (US & Canada), Mazatlán' },
  { value:"8", timezone: "America/Bahia_Banderas", name: '(GMT-6) Central Time (US & Canada), Mexico City' },
  { value:"9", timezone: "America/Atikokan", name: '(GMT-5) Eastern Time (US & Canada), Bogota, Lima' },
  { value:"10", timezone: "America/Anguilla", name: '(GMT-4) Central Brazil, Santiago, Caracas, La Paz' },
  { value:"11", timezone: "America/St_Johns", name: '(GMT-3:30) Canada (Newfoundland Standard Time)' },
  { value:"12", timezone: "America/Sao_Paulo", name: '(GMT-3) Greenland, East Brazil, Buenos Aires' },
  { value:"13", timezone: "America/Noronha", name: '(GMT-2) Falkland Islands, Mid-Atlantic' },
  { value:"14", timezone: "America/Scoresbysund", name: '(GMT-1) Azores, Cape Verde Islands' },
  { value:"15", timezone: "Africa/Bamako", name: '(UTC) Coordinated Universal Time' },
  { value:"16", timezone: "Africa/Bamako", name: '(GMT) Greenwich Mean Time, London, Lisbon' },
  { value:"17", timezone: "Africa/Algiers", name: '(GMT+1) Continental Europe, West Central Africa' },
  { value:"18", timezone: "Africa/Blantyre", name: '(GMT+2) Finland, Athens, Jerusalem, Bucharest' },
  { value:"19", timezone: "Africa/Blantyre", name: '(GMT+2) South Africa, Cairo, Istanbul, Beirut' },
  { value:"20", timezone: "Africa/Asmara", name: '(GMT+3) Saudi Arabia, Kuwait, Iraq, Nairobi' },
  { value:"21", timezone: "Africa/Asmara", name: '(GMT+3) Moscow, St. Petersburg, Volgograd' },
  { value:"22", timezone: "Africa/Asmara", name: '(GMT+3:30) Iran' },
  { value:"23", timezone: "America/Anguilla", name: '(GMT+4) Abu Dhabi, Muscat, Baku, Tbilisi, Yerevan' },
  { value:"24", timezone: "America/Caracas", name: '(GMT+4:30) Afghanistan' },
  { value:"25", timezone: "America/Atikokan", name: '(GMT+5) Pakistan, Islamabad, Tashkent, Ekaterinburg' },
  { value:"26", timezone: "Asia/Colombo", name: '(GMT+5:30) India, Sri Lanka' },
  { value:"27", timezone: "Asia/Katmandu", name: '(GMT+5:45) Nepal' },
  { value:"28", timezone: "Asia/Bishkek", name: '(GMT+6) Almaty, Novosibirsk, Astana, Dhaka' },
  { value:"29", timezone: "Asia/Rangoon", name: '(GMT+6:30) Myanmar, Cocos Islands' },
  { value:"30", timezone: "Asia/Phnom_Penh", name: '(GMT+7) Thailand, Jakarta, Krasnoyarsk' },
  { value:"31", timezone: "Australia/Perth", name: '(GMT+8) Western Australia, Kuala Lumpur, Singapore' },
  { value:"32", timezone: "Australia/Perth", name: '(GMT+8) Taiwan, Beijing, Hong Kong, Urumqi, Irkutsk' },
  { value:"33", timezone: "Australia/Perth", name: '(GMT+8) Western Australia (Caiguna-Eucla)' },
  { value:"34", timezone: "Asia/Dili", name: '(GMT+9) Japan, Korea, Yakutsk' },
  { value:"35", timezone: "Australia/Adelaide", name: '(GMT+9:30) South Australia, Northern Territory, Broken Hill' },
  { value:"36", timezone: "Antarctica/DumontDUrville", name: '(GMT+10) Eastern Australia, Guam, Hobart' },
  { value:"37", timezone: "Australia/LHI", name: '(GMT+10:30) Lord Howe Island' },
  { value:"38", timezone: "Pacific/Noumea", name: '(GMT+11) Solomon Islands, New Caledonia, Magadan' },
  { value:"39", timezone: "Pacific/Norfolk", name: '(GMT+11:30) Norfolk Island' },
  { value:"40", timezone: "Antarctica/McMurdo", name: '(GMT+12) New Zealand, Fiji, Kamchatka' },
  { value:"41", timezone: "Pacific/Chatham", name: '(GMT+12:45) New Zealand (Chatham Islands)' },
  { value:"42", timezone: "Pacific/Enderbury", name: '(GMT+13) Nuku’alofa' },
]

export const months = [
  { name: "January", value: 1 },
  { name: "February", value: 2 },
  { name: "March", value: 3 },
  { name: "April", value: 4 },
  { name: "May", value: 5 },
  { name: "June", value: 6 },
  { name: "July", value: 7 },
  { name: "August", value: 8 },
  { name: "September", value: 9 },
  { name: "October", value: 10 },
  { name: "November", value: 11 },
  { name: "December", value: 12 },
];

export const monthsList = [
  { name: "Jan", value: 1 },
  { name: "Feb", value: 2 },
  { name: "Mar", value: 3 },
  { name: "Apr", value: 4 },
  { name: "May", value: 5 },
  { name: "Jun", value: 6 },
  { name: "Jul", value: 7 },
  { name: "Aug", value: 8 },
  { name: "Sep", value: 9 },
  { name: "Oct", value: 10 },
  { name: "Nov", value: 11 },
  { name: "Dec", value: 12 },
];

export const aggregations = [
  { name: "Default", value: "default" },
  { name: "Max", value: "max" },
  { name: "Min", value: "min" }
];

export const snackBarVisiblePeriod = 3000;
export const defaultPageSize = 30;
export const mapMarkerIcon = "/images/station-pin.png";
export const loginBackground = "/images/earth-solar-main.png"

export const colorList = [
  "#61D257",
  "#BD7172",
  "#79CAE0",
  "#27870F",
  "#DC9C39",
  "#3AA1C0",
  "#87E095",
  "#30EFBD",
  "#0D5955",
  "#8222F6",
  "#C2164D",
  "#7D55DE",
  "#B0FAFB",
  "#7F8D9D",
  "#31064F",
  "#D02E76",
  "#BE3041",
  "#FF1F91",
  "#A112FA",
  "#02C081",
  "#051249",
  "#8F8C0C",
  "#EFB0F5",
  "#2963C5",
  "#EC8BD1",
  "#CD7EFB",
  "#88A05B",
  "#C4A849",
  "#D634AF",
  "#A8C249",
  "#317BF7",
  "#670176",
  "#C4A6CE",
  "#0A53FF",
  "#398FCC",
  "#90D0BD",
  "#81483C",
  "#EF186E",
  "#768CA7",
  "#BE13DD",
  "#07ED79",
  "#B0BF9E",
  "#C7DE03",
  "#C8A555",
  "#C03E41",
  "#B5893F",
  "#3E0FD9",
  "#DA1B92",
  "#F5AAAF",
  "#F70255",
  "#30ABAD",
  "#BEBCD9",
  "#5B476D",
  "#96340D",
  "#4F552A",
  "#B6B526",
  "#3E4FA2",
  "#90DE84",
  "#B1AF6A",
  "#CAA20D",
  "#CB4716",
  "#D55240",
  "#4D12C9",
  "#67B071",
  "#B4C66C",
  "#3287A9",
  "#E7E4A3",
  "#4E160D",
  "#F75A7C",
  "#C30896",
  "#5C8D42",
  "#73A574",
  "#8C3924",
  "#71BCC3",
  "#887810",
  "#E6D732",
  "#9A540C",
  "#998C3B",
  "#1ADD69",
  "#1E2873",
  "#9596DD",
  "#868EB8",
  "#A41315",
  "#F2FC06",
  "#6158AC",
  "#C325AF",
  "#336B11",
  "#4C6607",
  "#BFAABA",
  "#02C6A7",
  "#26A4C4",
  "#4F8AB9",
  "#CF5255",
  "#9153B1",
  "#EC3B2D",
  "#254CA0",
  "#1E098C",
  "#34B861",
  "#E0233E",
  "#42B8DE",
]